import * as browserHelper from './browserHelper';
import * as helpers from '../common/helpers';

const reportError = (err, extras = {}) => typeof helpers.lWindow === 'object' && browserHelper.hasRaven(helpers.lWindow) && helpers.lWindow.Raven.captureException(err, Object.assign({}, extras, {
  level: 'error'
}));

export default reportError;